var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSupportTermofuse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.057 25.067v-6.232L47.38 9.2H16.2c-.55 0-1 .451-1 1v51.58c0 .55.45 1 1 1h39.857c.55 0 1-.45 1-1V50.822",
    stroke: "#4EC689",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4EC689",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M47.38 9.2v9.348h9.677"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.529 18.822h17.808M21.529 25.932h23.936M21.529 33.042h23.936M21.529 40.151h17.808"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 2.71,
    d: "m52.916 38.758 3.163 2.821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.336 48.758-1.67-1.49a1.002 1.002 0 0 1-.08-1.412l12.33-13.825a1.003 1.003 0 0 1 1.411-.081l1.67 1.49c.41.366.447 1 .081 1.41l-12.33 13.826a1.003 1.003 0 0 1-1.412.081z",
    stroke: "#62EAA3",
    strokeWidth: 2.097,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62EAA3",
    d: "m43.854 47.56-1.06 5.213 5.17-1.548z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 1.747,
    strokeLinecap: "round",
    d: "m64.968 36.469-5.969 6.693"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 2.359,
    strokeLinecap: "round",
    d: "m62.271 29.545 1.956 1.744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 46s-2.857 5.023-2.581 6.462c.277 1.439 2.648-.959 3.96-2.59 1.312-1.632-.974 3.342-.974 3.342s-.072 1.197 1.123.446c0 0 5.536-5.634 5.284-4.988-.342.885-1.818 4.095-1.818 4.095s-.315.776.2.982c.516.206 1.232.277 1.953-.244C34.337 52.354 35 51.034 35 51.034M36.964 49s-3.258 5.023-2.942 6.463c.316 1.439 3.018-.96 4.515-2.591 1.495-1.632-1.111 3.342-1.111 3.342",
    stroke: "#4EC689",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupportTermofuse);
export default __webpack_public_path__ + "static/media/ic-support-termofuse.b2f4b98dd6bb7dc4d7c257aa4e1df6de.svg";
export { ForwardRef as ReactComponent };